/**
 * @traction/utils — boîte à outils JS partagée (16·R11/R20/R21).
 *
 * Chargé en module dans `layout/theme.liquid`. Les utilitaires sont aussi
 * exposés sur `window.Traction.utils` pour les scripts non-ESM legacy.
 *
 * Règle : le breakpoint JS ne peut pas diverger du CSS — `mediaLarge` et
 * `mediaDesktop` sont les DEUX SEULS matchMedia de layout du thème
 * (750px / 990px, identiques à base.css).
 */

/** matchMedia partagé — ≥ 750px (breakpoint « large » du CSS). */
export const mediaLarge = window.matchMedia('(min-width: 750px)');

/** matchMedia partagé — ≥ 990px (breakpoint « desktop » du CSS). */
export const mediaDesktop = window.matchMedia('(min-width: 990px)');

/** matchMedia partagé — préférence utilisateur de réduction de mouvement. */
export const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

/**
 * Débounce standard (remplace les réimplémentations locales — 16·R20).
 * @template {(...args: any[]) => void} T
 * @param {T} fn
 * @param {number} [wait=300] — délai en ms.
 * @returns {T}
 */
export function debounce(fn, wait = 300) {
  /** @type {number | undefined} */
  let timer;
  return /** @type {any} */ (
    function debounced(...args) {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => fn.apply(this, args), wait);
    }
  );
}

/**
 * Vrai si le clic est en dehors de `element` (16·R21).
 * Gère le cas `<dialog>` : un clic sur le ::backdrop cible le dialog
 * lui-même — on tranche par test géométrique sur le rectangle rendu.
 * @param {MouseEvent | PointerEvent} event
 * @param {Element} element
 * @returns {boolean}
 */
export function isClickedOutside(event, element) {
  if (element instanceof HTMLDialogElement && event.target === element) {
    const rect = element.getBoundingClientRect();
    return (
      event.clientX < rect.left ||
      event.clientX > rect.right ||
      event.clientY < rect.top ||
      event.clientY > rect.bottom
    );
  }
  return event.target instanceof Node === false || element.contains(event.target) === false;
}

/* Pont non-ESM. */
window.Traction = window.Traction || {};
window.Traction.utils = window.Traction.utils || {};
Object.assign(window.Traction.utils, { mediaLarge, mediaDesktop, reducedMotion, debounce, isClickedOutside });
